export const JIRA_AUTHENTICATION_PAGE_LABELS = {
	authenticationErrorTitle: 'Jira Authentication Error'
};
